declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/clients.scss';

import { h, Component } from 'preact';

export default class Clients extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {

        return <div class="mainWrp">
            <section class="clients">
              <h2>Our Clients</h2>
              <ul>
                <li>
                  <img id="client-hsbc" src={ STATIC_BASE_URL + 'images/public/clients_hsbc.jpg' } alt="HSBC" /></li><li>
                  <img id="client-pfizer" src={ STATIC_BASE_URL + 'images/public/clients_pfizer.png' } alt="Pfizer" /></li>
                <li>
                  <img id="client-pepsi" src={ STATIC_BASE_URL + 'images/public/clients_pepsi.jpg' } alt="Pepsi" /></li>
                <li>
                  <img id="client-philip-morris" src={ STATIC_BASE_URL + 'images/public/clients_philip-morris-international.jpg' } alt="Philip Morris International" /></li>
                <li>
                  <img id="client-forbes" src={ STATIC_BASE_URL + 'images/public/clients_forbes.png' } alt="FORBESE" /></li>
                <li>
                  <img id="client-ibm" src={ STATIC_BASE_URL + 'images/public/clients_ibm.png' } alt="IBM" /></li>
                <li>
                  <img id="client-tetrapak" style="" src={ STATIC_BASE_URL + 'images/public/clients_tetra-pak.jpg' } alt="Tetra Pak" /></li>
                <li>
                  <img id="client-lavazza" src={ STATIC_BASE_URL + 'images/public/clients_lavazza.png' } alt="Lavazza" /></li>
                <li>
                  <img src={ STATIC_BASE_URL + 'images/public/clients_svarosky.jpg' } id="client-svarosky" alt="Svarosky" /></li>
                <li>
                  <img id="client-yomiuri" src={ STATIC_BASE_URL + 'images/public/clients-the-yomiuri-shimbun.jpg' } alt="Yomiuri Shimbun" /></li>
                <li>
                  <img id="client-vfs" src={ STATIC_BASE_URL + 'images/public/clients_vfs.png' } alt="VFS.Global" /></li>
              </ul>
            </section>
          </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Clients.tsx